<template>
  <client-only>
    <div class="dropdown-container" @mouseleave="active = false">
      <template v-if="$auth.ready()" class="big">
        <template v-if="$auth.check()">
          <div
            @click="active = !active"
            class="dropdown-btn item"
            :class="{ active: active }"
          >
            {{ $t("header.dashboard") }}
          </div>
          <div v-if="active" class="dropdown-items">
            <router-link class="item" :to="{ name: 'dashboard' }">
              {{ $t("header.see") }}
            </router-link>
            <router-link v-if="user" class="item" :to="{
                name: 'model.username',
                params: { username: `@${user.username}` },
              }">
              {{ $t("header.my_wall") }}
            </router-link>
            <a class="item" :href="WEBSTARPANEL_URL">{{ $t("header.my_panel") }}</a>
            <a class="item" v-if="chatUrl" :href="chatUrl">{{ $t("header.my_chat") }}</a>
            <a class="item" href="https://www.divasplay.info" target="_blank">
              {{ $t("header.tutorials") }}
            </a>
            <a @click.prevent="$auth.logout()" class="item" href="#">
              {{ $t("header.logout") }}
            </a>
          </div>
        </template>
        <template v-else>
          <div
            @click="active = !active"
            class="dropdown-btn item"
            :class="{ active: active }"
          >
            {{ $t("header.login") }}
          </div>
          <div v-if="active" class="dropdown-items">
            <router-link class="item" :to="{ name: 'login' }">
              {{ $t("header.login_user") }}
            </router-link>
            <a v-if="webstarsPanelUrl" class="item" :href="webstarsPanelUrl">
              {{ $t("header.webstars_panel") }}
            </a>
            <router-link class="item" :to="{ name: 'signup' }">
              {{ $t("header.register") }}
            </router-link>
            <a class="item" href="https://www.divasplay.info" target="_blank">
              {{ $t("header.tutorials") }}
            </a>
          </div>
        </template>
      </template>
      <template v-else>
        <a class="item" href="#">
          {{ $t("loading") }}
        </a>
      </template>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import _NuxtApp from "@/types/NuxtApp";
import { User } from '~/types/User';

import resources from "@/utils/resources";

const { $auth } = <_NuxtApp>useNuxtApp();

const env = useRuntimeConfig().public;

const WEBSTARPANEL_URL = env.VUE_APP_WEBSTARS_PANEL_URL;      
const webstarsPanelUrl = "/login?redirect=webstars-panel";
const active = ref(false);
const chatUrl = ref(null);
const user = ref<User>();

// const { style } = withDefaults(defineProps<{ style: string }>(), {
//   style: "",
// });

onMounted(() => {

  $auth.user().then((response) => {
    if (!response) return;
    user.value = response;
  });

  if(env.VUE_APP_CHAT_ENABLED) {
    resources.chat.getHomeUrl().then((data) => {
      if (!data.success) return;
      chatUrl.value = data.url;
    }).catch(() => null);
  }
});
</script>

<style lang="scss" scoped>
.dropdown-container {
  position: relative;
  flex-grow: 1;

  .dropdown-btn {
    cursor: pointer;

    &.active {
      cursor: default;
    }
  }

  .dropdown-items {
    width: 100%;
    position: absolute;
    top: 100%;
    z-index: 99;
    background: var(--background_01);
  }

  .item {
    min-width: 120px;
    display: block;
    text-align: center;
    color: inherit;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 16px;
    padding: 0.75em 0;
    flex-grow: 1;
    transition: background-color 0.2s ease-in-out;

    &.router-link-active {
      background-color: lighten(#000000, 50);
    }

    // &:hover{
    //     background-color: lighten(#000000, 30);
    // }

    &:hover {
      background-color: var(--pallete_clear_text_color);
      color: var(--pallete_dark_color);
    }
  }
}
</style>
